import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {RefundTypes} from "../../../types/transaction/transaction.types";
import {getMemberRefundDetail} from "../../../api/transaction/refundApi";
import {formatDateTime, setComma} from "../../../utils/format";

const RefundDetailPage = () => {

    const {id} = useParams<{ id: string }>();

    const [refundData, setRefundData] = useState<RefundTypes>();
    const [loading, setLoading] = useState(true);


    const getRefundData = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const result = await getMemberRefundDetail(id);
            if (result.data.code == "00") {
                setRefundData(result.data.data);
            }
        } catch (err) {
            console.error('잔액환불 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getRefundData();
    }, [])

    return (
        <>
            {(!loading && refundData) && (() => {
                const isMinus = refundData.status == "COMPLETED";
                return (
                    <div>

                        <main className="container type_gray">
                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">기본 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">잔액환불금액</span>
                                            <span className="txt">{setComma(refundData.refundAmount)} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">잔액환불 요청일시</span>
                                            <span className="txt">{formatDateTime(refundData.regDate)}</span>
                                        </li>
                                        <li>
                                            <span className="tit">잔액환불 완료일시</span>
                                            <span className="txt">{formatDateTime(refundData.refundDate)}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래번호</span>
                                            <span className="txt">{refundData.refundRequestCode}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래상태</span>
                                            <span className={isMinus ? "status finish" : "status"}>{refundData.statusDescription}</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">잔액환불 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">잔액환불 대상금액</span>
                                            <span className="txt">{setComma(refundData.refundableAmount)} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">잔액환불 수수료</span>
                                            <span className="txt">{setComma(refundData.refundFee)} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">지급 은행</span>
                                            <span className="txt">{refundData.bankName}</span>
                                        </li>
                                        <li>
                                            <span className="tit">지급 계좌</span>
                                            <span className="txt">{refundData.bankAccount}</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section>
                                <div className="inner">
                                    <ul className="guidF-list">
                                        <li>잔액환불요청 후 3영업일 이내 잔액환불신청 시 입력된 계좌로 잔액환불금액이 지급됩니다.</li>
                                        <li>잔액환불요청 후 등록된 계좌를 변경 시 변경도니 계좌로 잔액환불금액이 지급되지 않으니 잔액환불 요청 시 유의하시기 바랍니다.</li>
                                    </ul>
                                </div>
                            </section>
                        </main>
                    </div>
                );
            })
            ()}
        </>


    );
};

export default RefundDetailPage;

